export function formatDateTime(dateObject) {
  let result=
  {
    year:dateObject.getYear(),
    fullYear:dateObject.getFullYear(),
    month:dateObject.getMonth(),
    day:dateObject.getDate(),
    weekday:dateObject.getDay(),
    time:dateObject.getTime(),
    hour:dateObject.getHours(),
    minute:dateObject.getMinutes(),
    second:dateObject.getSeconds(),
    millisecond:dateObject.getMilliseconds()
  };
  let monthMap = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  result.monthName = monthMap[result.month];
  let weekdayMap = ['Sun','Mon','Tues','Wed','Thur','Fri','Sat'];
  result.weekdayName = weekdayMap[result.weekday];
  ++ result.month;
  result.fullMonth = result.month < 10 ? '0' + result.month : result.month;
  result.fullDay = result.day < 10 ? '0' + result.day : result.day;
  result.fullHour = result.hour < 10 ? '0' + result.hour : result.hour;
  result.fullMinute = result.minute < 10 ? '0' + result.minute : result.minute;
  result.fullSecond = result.second < 10 ? '0' + result.second : result.second;     
  return result;
};


// WEBPACK FOOTER //
// ./src/utils/date-format.js